<template>
  <el-dialog
    title="召回原因"
    :visible="isShow"
    width="500px"
    :before-close="handleRecallClose"
  >
    <div class="recall-container">
      <span>*</span>
      <el-input
        v-model="recalltext"
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 6}"
        placeholder="请输入召回原因"
      />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleRecallClose">取消</el-button>
      <el-button type="primary" @click="submitRecall">确认召回</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {
  revokeApply
} from '@/API';
export default {
  data () {
    return {
      isShow: false,
      recalltext: '',
      currentItem: {}
    };
  },
  methods: {
    openDialog (row) {
      this.currentItem = row;
      this.isShow = true;
    },

    // 确认召回
    submitRecall () {
      if (!(this.recalltext && this.recalltext.length)) {
        this.$message.error('召回原因必填');
        return;
      }
      revokeApply({
        id: this.currentItem.id,
        approvalOpinion: this.recalltext
      }).then(({ status }) => {
        console.log(status, status === 200, 'alksmals');
        if (status === 200) {
          this.$emit('set-data');
          this.handleRecallClose();
          this.$message.success('操作成功');
        }
      });
    },

    handleRecallClose () {
      this.isShow = false;
      this.recalltext = '';
      this.currentItem = {};
    }
  }
};
</script>
<style lang="scss">
.recall-container {
  display: flex;
  >span {
    color: red;
    margin-right: 5px;
  }
}
</style>
